// @ts-nocheck


import React from 'react';
import { TabItem, Tabs } from './../../../../../components/ui';





export default ({ vehiclePlanId }) =>
<Tabs withRouter>
    <TabItem
    label="Пропуска весенний период"
    url={`/budget/vehicle/${vehiclePlanId}/spring-pass`} />

    <TabItem
    label="Пропуска негабарит"
    url={`/budget/vehicle/${vehiclePlanId}/cargo-pass`} />

  </Tabs>;
